import React, { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { createSelector } from 'reselect';
import get from 'lodash.get';
import Global from '../../store/global-selectors';
import TagButton from '../../components/grid-header/tag-button';
import * as OrderActions from '../../store/orders/orders.actions';
import { emptyArray } from 'ui-components/default-props/empty';

const getSelectedData = (fulfillmentPlans) => {
  const selectedTagIds = new Set();
  const selectedTagsCount = {};
  fulfillmentPlans.forEach((fulfillmentPlan) => {
    const tags = get(fulfillmentPlan, 'tagIds', emptyArray);
    tags.forEach((tag) => {
      selectedTagIds.add(tag);
      if (selectedTagsCount[tag]) {
        selectedTagsCount[tag] += 1;
      } else {
        selectedTagsCount[tag] = 1;
      }
    });
  });
  return {
    selectedTagsCount,
    selectedTagIds: [...selectedTagIds],
  };
};

const selectedDataSelector = createSelector((fulfillmentPlans) => fulfillmentPlans, getSelectedData);

const selectedTagsSelector = createSelector(
  (tags) => tags,
  (_, selectedTagIds) => selectedTagIds,
  (tags, selectedTagIds) =>
    tags.filter(
      (tag) =>
        selectedTagIds.filter((tagId) => {
          return tagId && tagId.valueOf() === tag.tagId.valueOf();
        }).length !== 0,
    ),
);

const OrdersTagButton = () => {
  const dispatch = useDispatch();
  const tags = useSelector(Global.selectSellerTags) || emptyArray;
  const selectedFulfillmentPlanIds = useSelector(Global.selectSelectedOrdersIds) || emptyArray;
  const shouldBeDisabled = !selectedFulfillmentPlanIds.length;
  const fulfillmentPlans =
    useSelector((state) =>
      Global.selectEntitiesFulfillmentPlansByIds(state, {
        fulfillmentPlanIds: selectedFulfillmentPlanIds,
      }),
    ) || emptyArray;
  const { selectedTagsCount, selectedTagIds } = selectedDataSelector(fulfillmentPlans);
  const selectedTags = selectedTagsSelector(tags, selectedTagIds);

  const addTag = useCallback(
    (fulfillmentPlanIds, tagId) => dispatch(OrderActions.addTagsToFulfillmentPlans(fulfillmentPlanIds, [tagId])),
    [dispatch],
  );
  const removeTag = useCallback(
    (fulfillmentPlanIds, tagId) => dispatch(OrderActions.removeTagsFromFulfillmentPlans(fulfillmentPlanIds, [tagId])),
    [dispatch],
  );

  return (
    <TagButton
      addTag={addTag}
      removeTag={removeTag}
      selectedIds={selectedFulfillmentPlanIds}
      selectedTags={selectedTags}
      selectedTagsCount={selectedTagsCount}
      shouldBeDisabled={shouldBeDisabled}
      tags={tags}
    />
  );
};

export default OrdersTagButton;
